import {IconButton} from '@material-ui/core';
import {Visibility, VisibilityOff, VpnKey} from '@material-ui/icons';
import React, {useState} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {IInputPassword} from 'MyModels';
import {Input} from '../../shared/components';
import {ButtonSubmit} from '../../shared/components/buttons';
import ButtonWhatsApp from '../../shared/components/buttons/ButtonWhatsApp';
import DetachedIcon from '../../shared/components/detachedIcon';
import HelpSection from '../election/components/HelpSection';
import Screen from '../election/screen';
import {updatePwdAsync} from './store/actions';
import {getInfo} from './store/selectors';

type EventHandler = React.ReactEventHandler<HTMLInputElement>;

const ChangePassword: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {loading, message} = useSelector(getInfo);
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [inputs, setInputs] = useState<IInputPassword>({
    password: '',
    password_confirmation: '',
  });

  const handleInputChange: EventHandler = ev => {
    setInputs({
      ...inputs,
      [ev.currentTarget.name]: ev.currentTarget.value,
    });
  };

  const changePassword = (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault();
    dispatch(updatePwdAsync.request(inputs));
  };

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Screen>
      <form className="auth-form boxed-forms-300" onSubmit={changePassword}>
        <DetachedIcon size="sm" icon={<VpnKey />} />

        <h2 className="primary-title">{t('autenticacao.alterar-senha')}</h2>
        <p className="default-subtitle mt-0 text-center">
          <Trans
            i18nKey="autenticacao.text-alterar-senha"
            shouldUnescape={true}
            components={{b: <b />}}
            values={{characters: escape('<, >, &')}}
          />
        </p>

        <div className="show-password-box full-width">
          <Input
            className="full-width"
            label={t('autenticacao.nova-senha')}
            placeholder={t('autenticacao.nova-senha')}
            name="password"
            type={showPassword ? 'text' : 'password'}
            required={true}
            autoFocus={false}
            value={inputs.password}
            inputProps={{tabIndex: 1}}
            onChange={handleInputChange}
          />
          <IconButton
            aria-label="delete"
            className={`button-show-password `}
            type="button"
            color="primary"
            onClick={toggleShowPassword}
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </div>

        <div className="show-password-box full-width">
          <Input
            className="full-width"
            label={t('autenticacao.repita-nova-senha')}
            placeholder={t('autenticacao.confirmar-nova-senha')}
            name="password_confirmation"
            type={showPassword ? 'text' : 'password'}
            required={true}
            autoFocus={false}
            inputProps={{tabIndex: 2}}
            value={inputs.password_confirmation}
            onChange={handleInputChange}
          />
          <IconButton
            aria-label="delete"
            className={`button-show-password `}
            type="button"
            color="primary"
            onClick={toggleShowPassword}
          >
            {showPassword ? <Visibility /> : <VisibilityOff />}
          </IconButton>
        </div>

        {message && <p style={{color: 'red'}}>{message}</p>}

        <ButtonSubmit
          customClasses="full-width"
          classColor="green"
          loading={loading}
          translate={{
            init: t('autenticacao.salvar-nova-senha'),
            loading: t('autenticacao.salvando'),
          }}
        />

        <HelpSection />
      </form>

      <ButtonWhatsApp />
    </Screen>
  );
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/features/auth/ChangePassword.tsx